import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

(function () {
  if(!document.querySelector(".wp-block-gallery")) return this;

  function forEach( list, callback ) {
    Array.prototype.forEach.call( list, callback );
  }

  let wpBlockGalleries = document.querySelectorAll(".wp-block-gallery");
  wpBlockGalleries.forEach(function(wpBlockGallery) {
      wpBlockGallery.classList.add("swiper");
      let swiperWrapper = document.createElement("div");
      swiperWrapper.classList.add("swiper-wrapper");
      let wpBlockImages = wpBlockGallery.querySelectorAll(".wp-block-image");
      wpBlockImages.forEach(function(wpBlockImage) {
          wpBlockImage.classList.add("swiper-slide");
          swiperWrapper.appendChild(wpBlockImage);
      });
      wpBlockGallery.appendChild(swiperWrapper);
      let swiperButtonPrev = document.createElement("div");
      swiperButtonPrev.classList.add("swiper-button-prev");
      wpBlockGallery.appendChild(swiperButtonPrev);
      let swiperButtonNext = document.createElement("div");
      swiperButtonNext.classList.add("swiper-button-next");
      wpBlockGallery.appendChild(swiperButtonNext);
      let swiperPagination = document.createElement("div");
      swiperPagination.classList.add("swiper-pagination");
      wpBlockGallery.appendChild(swiperPagination);
  });

  const swiper_sec = new Swiper('.wp-block-gallery', {
    loop: true,
    calculateHeight: true,
    spaceBetween: 19,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    //ページネーション
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    }
  });
})();
